if(document.querySelector(".slideshow__text")){
  var slideshows = document.querySelectorAll(".slideshow__text .banner__buttons a");
  for(var n = 0; n < slideshows.length; n++){
    let index = n;
    console.log(slideshows.item(n).getAttribute("href"))
    slideshows.item(index).closest(".slideshow__text-wrapper").addEventListener("click", function(e){ 
      window.location.href = slideshows.item(index).getAttribute("href");
    });
  }
}


var modal = document.createElement('div');
  modal.className = 'modal';
  var video = document.createElement('div');
video.classList.add("popup-video");
video.innerHTML = '<video controls="controls" autoplay="autoplay" height="auto" width="80%"><source src="https://cdn.shopify.com/videos/c/o/v/4846b951c668455fbf47f2649c56727a.mp4" type="video/mp4"></video>';
  // video.src='https://cdn.shopify.com/videos/c/o/v/4846b951c668455fbf47f2649c56727a.mp4';
  // video.width = '100%';
  modal.appendChild(video);
  
  document.querySelector('#HeaderMenu-como-funciona').addEventListener('click', function() {
    document.body.appendChild(modal);
  });
  
  document.addEventListener('click', function(e) {
    if (e.target === modal || e.target === video) {
      modal.parentNode.removeChild(modal);
    }
  });

// document.querySelector(".metafield-rich_text_field p").forEach((element) => console.log(element));
var slides = document.querySelectorAll(".product-term-list p");
for (var i = 0; i < slides.length; i++) {
   if(slides.item(i).innerHTML == "decoloración + color"){
     slides.item(i).innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0822/7205/9675/files/1.svg?v=1702221050" /> decoloración + color'
   }
   if(slides.item(i).innerHTML == "protección térmica"){
     slides.item(i).innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0822/7205/9675/files/2.svg?v=1702221047" /> protección térmica'
   }
   if(slides.item(i).innerHTML == "servicios químicos"){
     slides.item(i).innerHTML = '<img src="https://cdn.shopify.com/s/files/1/0822/7205/9675/files/3.svg?v=1702221045" /> servicios químicos'
   }
}
document.getElementById("Details-HeaderMenu-2").addEventListener("mouseover", function (){
  document.getElementById("Details-HeaderMenu-2").setAttribute("open", true)
});
document.getElementById("Details-HeaderMenu-2").addEventListener("mouseout", function (){
  document.getElementById("Details-HeaderMenu-2").removeAttribute("open")
});
document.getElementById("Details-HeaderMenu-3").addEventListener("mouseover", function (){
  document.getElementById("Details-HeaderMenu-3").setAttribute("open", true)
});
document.getElementById("Details-HeaderMenu-3").addEventListener("mouseout", function (){
  document.getElementById("Details-HeaderMenu-3").removeAttribute("open")
});

var socialLinks = document.querySelectorAll(".list-social__link");
for (var i = 0; i < socialLinks.length; i++) {
  socialLinks.item(i).setAttribute("target", "_blank")
}

const blogHeader = document.getElementById("header-blog");
if(blogHeader){
  var element = document.querySelector(".blog-articles__article.article:first-child .card.article-card");
  blogHeader.innerHTML = element.innerHTML
}

document.querySelector(".modal-dialog.modal-confirm .modal-title").innerHTML = "¡Gracias!"
document.querySelector(".modal-dialog.modal-confirm .modal-body .text-center").innerHTML = "Envío exitoso."

var strongs = document.querySelectorAll(".product .accordion__content strong");
for (var i = 0; i < strongs.length; i++) {
  if(strongs.item(i).innerHTML == "check"){
     strongs.item(i).innerHTML = '<img class="icon-check" src="https://cdn.shopify.com/s/files/1/0822/7205/9675/files/green-check-mark-icon-on-transparent-background-free-png.webp?v=1703558757" />'
   }
  if(strongs.item(i).innerHTML == "equis"){
     strongs.item(i).innerHTML = '<img class="icon-equis" src="https://cdn.shopify.com/s/files/1/0822/7205/9675/files/red-cross-check-mark-on-transparent-background-free-png.webp?v=1703558758" />'
   }
}
if(document.querySelector(".cart__empty-text")){
document.querySelector(".cart__empty-text").innerHTML = "Tu carrito está vacío"  
}

function showTab(pos){
  console.log(pos);
  var texts = document.querySelectorAll(".nav-slider__text li");
  for (var i = 0; i < texts.length; i++) {
    texts.item(i).className = 'hidden'
  }
  texts.item(pos).className = '';
  var imagesLi = document.querySelectorAll(".nav-slider__image > ul > div > div > li");
  for (var i = 0; i < imagesLi.length; i++) {
    imagesLi.item(i).className = ''
  }
  imagesLi.item(pos).className = 'is-selected';
  
  var menuItems = document.querySelectorAll(".nav-slider__nav > li");
  for (var i = 0; i < menuItems.length; i++) {
    menuItems.item(i).className = ''
  }
  menuItems.item(pos).className = 'is-selected is-nav-selected'
  

  // document.querySelector(".nav-slider__text li")
}

if(document.querySelector(".bio-slider")){
  var bioSlides = document.querySelectorAll(".bio-slider > div");
  var bioSlidesSteps = document.querySelectorAll(".bio-slider-steps > div");

  for(var m = 0; m < bioSlidesSteps.length; m++){
    const index = m;
    bioSlidesSteps.item(m).addEventListener("click", () => {
      
      for (var n = 0; n < bioSlides.length; n++) {
        bioSlides.item(n).setAttribute("style", "display: none;");
        bioSlidesSteps.item(n).className = "";
      }
      bioSlides.item(index).setAttribute("style", "display: flex; align-items: center");
      bioSlidesSteps.item(index).className = "active";
    })
  }
}

if(document.querySelector(".last-slider")){
  var fslides = document.querySelectorAll(".last-slider > div");
  var fslidesSteps = document.querySelectorAll(".last-slider-steps > div");

  for(var m = 0; m < fslidesSteps.length; m++){
    const index = m;
    fslidesSteps.item(m).addEventListener("click", () => {
      
      for (var n = 0; n < fslides.length; n++) {
        fslides.item(n).setAttribute("style", "display: none;");
        fslidesSteps.item(n).className = "";
      }
      fslides.item(index).setAttribute("style", "display: flex; align-items: center");
      fslidesSteps.item(index).className = "active";
    })
  }
}

if(document.querySelector(".last-slider-mobile")){
  var fslidesMobile = document.querySelectorAll(".last-slider-mobile > div");
  var fslidesStepsMobile = document.querySelectorAll(".last-slider-steps-mobile > div");

  for(var m = 0; m < fslidesStepsMobile.length; m++){
    const index = m;
    fslidesStepsMobile.item(m).addEventListener("click", () => {
      
      for (var n = 0; n < fslidesMobile.length; n++) {
        fslidesMobile.item(n).setAttribute("style", "display: none;");
        fslidesStepsMobile.item(n).className = "";
      }
      fslidesMobile.item(index).setAttribute("style", "display: flex; align-items: center");
      fslidesStepsMobile.item(index).className = "active";
    })
  }
}

if(document.querySelector(".section-template--20835873128731__8e402bb4-c85a-4f23-a762-78541ac4572d-padding")){
  let h2 = document.createElement("h2");
  h2.className = "image-with-text__heading hide-on-desktop";
  h2.innerHTML = document.querySelector(".section-template--20835873128731__8e402bb4-c85a-4f23-a762-78541ac4572d-padding .image-with-text__heading").innerHTML
  document.querySelector(".section-template--20835873128731__8e402bb4-c85a-4f23-a762-78541ac4572d-padding").prepend(h2);
}














